import React from "react";
import { Box } from "@mui/material";
import RouteTimeline from "../../../DriversReport/DriversReportTracker/components/RouteTimeline";

const RoutesCoverage = ({ deliveryRoutes }) => {

  console.log("deliveryroutes",deliveryRoutes)
  if (!deliveryRoutes || deliveryRoutes.length === 0) {
    return null;
  }

  const stops = deliveryRoutes.map((route) => ({
    stopId: `STOP-${String(route.stop_number).padStart(2, "0")}`,
    stopNumber: route.stop_number,
    location: route.stop_name,
    address: route.stop_name,
    status: route.stop_state,
    returns_orders: route.returns_orders || 0,
    partial_orders: route.partial_orders || 0,
    total_delivered_order: route.total_delivered_order || 0,
    orders: route.order_list.map((order) => ({
      orderNo: order.order_number,
      customerName: order.customer_name,
      customerCode: order.customer_code,
      phone: order.customer_phone ? `${order.customer_phone}` : "N/A",
      status: order.order_state,
      priority: order.order_tag === "Urgent" ? "urgent" : "normal",
      items: order.line_items.map((item) => ({
        code: item.item_code,
        description: item.item_description,
        quantity: item.item_loaded_qty,
        remarks: item.delivery_order_line_remarks,
        colorState: item.order_line_color_satate,
      })),
      orderDate: order.order_date,
      loadedTime: order.order_loaded,
      deliveredTime: order.order_delivered,
      deliveryStartTime: order.order_delivery_start,
      totalDeliveryTime : order.delivery_time_hours,

      notes: order.order_state === "Failed" ? "Delivery failed" : null,
      signature_files: order.signature_files,
      other_files: order.other_files,
      is_return_job: order.is_return_job,
      return_job_color: order.return_job_color,
      is_partial_job: order.is_partial_job,
      partial_job_color: order.partial_job_color,
      order_reason: order.order_reason,
    })),
    timeline: [],
    estimatedArrival: null,
  }));

  return (
    <Box>
      <RouteTimeline stops={stops} currentStop={null} />
    </Box>
  );
};

export default RoutesCoverage;
